import { axiosInstanceWithToken } from "@/helpers/axios";
import { useMutation, useQuery } from "react-query";

export function useApiGet({
  endpoint,
  config = {},
  queryKey,
  axiosConfig = {},
  axiosKey = "auth",
}) {
  const queryOptions = {
    ...config,
  };

  const query = useQuery(
    queryKey || [endpoint],
    () => axiosInstanceWithToken.get(endpoint, axiosConfig),
    {
      ...queryOptions,
    }
  );

  return query;
}

export function useApiMutation({
  endpoint,
  method,
  config = {},
  axiosConfig = {},
  sendDataInParams = false,
}) {
  const queryOptions = {
    ...config,
  };

  const mutation = useMutation(
    (params) => {
      let url = endpoint;
      if (sendDataInParams) {
        // Construct URL with query params
        const queryString = Object.values(params)
          .map((key) => `/${key}`)
          .join("");
        url += `${queryString}`;
        return axiosInstanceWithToken[method](url, {}, axiosConfig); // No data in the body, sending empty object
      }
      return axiosInstanceWithToken[method](url, params, axiosConfig); // No data in the body, sending empty object
    },
    {
      ...queryOptions,
    }
  );

  return mutation;
}
